var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.779,
    height: 33.568,
    viewBox: "0 0 101.779 33.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#ffff;}.a{font-size:9px;font-family:Rockwell-BoldItalic, Rockwell;font-weight:700;font-style:italic;letter-spacing:0.097em;}.v{fill:#ff9017;}.v{font-size:9px;font-family:Rockwell-BoldItalic, Rockwell;font-weight:700;font-style:italic;letter-spacing:0.097em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15291.749 -14649.716)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "v",
    transform: "translate(-15242.97 14680.284)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REWARDS")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15291.749 14649.716)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.016,327.027l3.027,1a8.483,8.483,0,0,1-1.457,1.684,9.291,9.291,0,0,1-1.8,1.3,7.855,7.855,0,0,1-2.071.819,8.311,8.311,0,0,1-2.276.3A9.077,9.077,0,0,1,40.024,316.6a8.609,8.609,0,0,1,6.418-2.686,8.91,8.91,0,0,1,3.55.706,9.446,9.446,0,0,1,2.913,1.98l-2.185,2.139a6.043,6.043,0,0,0-10.333,4.279,5.985,5.985,0,0,0,6.054,6.054,6.183,6.183,0,0,0,2.526-.524A6.341,6.341,0,0,0,51.016,327.027Zm-4.574-5.507h7.6l-3.027,3.027H46.442Z",
    transform: "translate(-37.338 -313.897)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M184.4,313.918v3.05h-9.1l-3.027-3.05Zm-9.1,7.6h9.1v3.027H172.266V321.52Zm0,7.556h9.1v3.05H172.266v-.251Z",
    transform: "translate(-152.877 -313.897)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M300.489,313.757V331.9l-15.081-13.562v-4.581l12.064,10.863V313.757Z",
    transform: "translate(-251.021 -313.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M581.607,313.918v11.038l-3.027,3.05V313.918Z",
    transform: "translate(-508.267 -313.897)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M458.634,319.221a5.227,5.227,0,0,0-1.547-3.733,5.236,5.236,0,0,0-3.755-1.57h-9.855v15.462l3.027-3.05v-1.784h6.827a2.507,2.507,0,0,1,.911.182,2.214,2.214,0,0,1,.7.5,2.28,2.28,0,0,1,0,3.186,1.888,1.888,0,0,1-.751.5,2.243,2.243,0,0,1-.865.16H446.5v3.05h6.827a5.133,5.133,0,0,0,2.048-.41,5.268,5.268,0,0,0,1.708-1.16,5.226,5.226,0,0,0,1.547-3.732,5.054,5.054,0,0,0-1.593-3.8A5.121,5.121,0,0,0,458.634,319.221Zm-3.208.887a2.249,2.249,0,0,1-.479.728,2.361,2.361,0,0,1-1.616.683H446.5v-4.552h6.827a2.245,2.245,0,0,1,.865.159,1.9,1.9,0,0,1,.751.5,2.358,2.358,0,0,1,.66,1.593A2.289,2.289,0,0,1,455.426,320.109Z",
    transform: "translate(-391.128 -313.897)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M590.71,427.591v3.05h-12.13l3.027-3.05Z",
    transform: "translate(-508.305 -412.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M680.691,317.764v6.783a4.553,4.553,0,0,1-9.1,0V313.918h-3.026v10.629a7.459,7.459,0,0,0,2.208,5.371,7.3,7.3,0,0,0,5.348,2.208h.046a7.3,7.3,0,0,0,5.348-2.208,7.459,7.459,0,0,0,2.208-5.371v-6.783Z",
    transform: "translate(-583.376 -313.897)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.cd31d539f1af48b2f112a191ab68c4b1.svg";
export { ForwardRef as ReactComponent };